import type { NavItem, SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Updraft',
    legalName: 'Updraft Studio',
    description: "Updraft is a social media studio for brands that want to be talked about. We forecast what is about to trend, launch content into the feed and read the room afterwards. Catch the lift.",
    url: 'https://updraft.modulify.website',
    ogImage: '/images/social/studio-4.jpg',
    email: 'hello@updraft.studio',
    phone: '+44 20 7946 0958',
    phoneHref: 'tel:+442079460958',
    address: "Unit 7, Shoreditch Studios, London",
    socials: [
        { platform: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/updraft.studio' },
        { platform: 'tiktok', label: 'TikTok', href: 'https://www.tiktok.com/@updraft.studio' },
        { platform: 'youtube', label: 'YouTube', href: 'https://www.youtube.com/@updraftstudio' },
        { platform: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/company/updraft-studio' },
        { platform: 'x', label: 'X', href: 'https://x.com/updraftstudio' }
    ]
}

export const TAGLINE = 'Catch the lift.'

export const mainNav: Array<NavItem> = [
    { label: 'Work', href: '/work' },
    { label: 'Services', href: '/services' },
    { label: 'The Lab', href: '/lab' },
    { label: 'Playbook', href: '/playbook' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Studio', href: '/studio' },
    { label: 'Journal', href: '/journal' },
    { label: 'Contact', href: '/contact' }
]

export const mobileNav: Array<NavItem> = mainNav

export const footerPages: Array<NavItem> = [
    { label: 'Front page', href: '/' },
    { label: 'Work', href: '/work' },
    { label: 'Services', href: '/services' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Journal', href: '/journal' }
]

export const footerStudio: Array<NavItem> = [
    { label: 'Studio', href: '/studio' },
    { label: 'The Lab', href: '/lab' },
    { label: 'Playbook', href: '/playbook' },
    { label: 'Contact', href: '/contact' }
]

export const footerLegal: Array<NavItem> = [
    { label: 'Privacy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' }
]

export const CONTACT_HREF = '/contact'

export const START_HREF = '/contact'

export const START_LABEL = 'Get a forecast'
